import AntIcon from "@/components/icons/AntIcon";
import { useToken } from "@/utils/hooksUtils";
import { Badge, Button, Flex, Popover } from "antd";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  count: number;
  title: ReactNode;
  children: ReactNode;
};

export const CalcDiscountsButton = ({ count, title, children }: Props) => {
  const { t } = useTranslation();
  const { token } = useToken();

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      title={title}
      content={
        <Flex vertical gap="small" style={{ width: 260 }}>
          {children}
        </Flex>
      }
    >
      <Badge count={count} size="small" color={token.colorPrimary}>
        <Button icon={<AntIcon type="percentage" />}>{t("calc.actions.discounts")}</Button>
      </Badge>
    </Popover>
  );
};
